export const PrivateMobileFive = () => {
    return <div>
        <div className="mt-[45px] flex justify-center px-[45px]"><div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">多分支、多场景智能组网</div></div>
        <div className="text-[8px] font-light text-[rgba(51,51,51,1)] text-center mt-[4px]">设计架构灵活、可以快速部署企业专用全球网络，满足国内、国外各个场景需求</div>
        <img src="/imgs/private/branch.png" className="w-full mt-[20px]" />
    </div>
}